import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import transition from 'styled-transition-group';
import { position } from 'polished';
import fp from 'lodash/fp';
import { size, color, getLayer, media } from '@deerplusofficial/pos-helper';
import { ButtonBase as Button, Icon } from '@deerplusofficial/pos-components';

const IN_VIEW = 'translate(0)';

const OUT_OF_VIEW = {
  true: `translate(0, 100%)`,
  false: `translate(0, calc(100% - ${size.toolbarToggle}))`,
};

const Container = transition.div.attrs({
  timeout: 400,
})`
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: calc(100% - ${size.topbar.mobile});
  z-index: ${getLayer('cart')};
  transition: transform .4s ease-in-out;
  ${position('fixed', size.topbar.mobile, null, null, 0)};
  ${({ active, readonly }) =>
    active
      ? css`
          transform: ${IN_VIEW};
        `
      : css`
          transform: ${OUT_OF_VIEW[readonly]};
        `};
  ${({ readonly }) => css`
    &:enter {
      transform: ${OUT_OF_VIEW[readonly]};
    }
    &:enter-active,
    &:exit {
      transform: ${IN_VIEW};
    }
    &:exit-active {
      transform: ${OUT_OF_VIEW[readonly]};
    }
  `}
`;

const Toggle = styled(Button)`
  width: 100%;
  background-color: ${color.accent};
  color: white;
  ${media(
    'tablet',
    css`
      display: none;
    `
  )};
`;

const ToggleInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  height: ${size.toolbarToggle};
`;

const ToggleIcon = styled(Icon)`
  margin-left: 13px;
`;

class Toolbar extends Component {
  static propTypes = {
    active: PropTypes.bool,
    readonly: PropTypes.bool,
    label: PropTypes.string,
    onToggleClick: PropTypes.func,
  };

  static defaultProps = {
    active: false,
    readonly: false,
    label: '',
    onToggleClick: fp.identity,
  };

  render() {
    const {
      children,
      active,
      readonly,
      label,
      onToggleClick,
      ...props
    } = this.props;

    return (
      <Container in={active} active={active} readonly={readonly} {...props}>
        {!readonly && (
          <Toggle onClick={onToggleClick}>
            <ToggleInner>
              {label}
              <ToggleIcon icon={active ? 'chevron-down' : 'chevron-up'} />
            </ToggleInner>
          </Toggle>
        )}
        {children}
      </Container>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Toolbar/Toolbar.js